define("powergen/views/index",
  [],
  function() {
    "use strict";
    var IndexView;

    IndexView = Ember.View.extend({
      click: function(e) {
        return this.get('controller').send('click');
      },
      didInsertElement: function() {
        return this.set('controller.view', this);
      }
    });


    return IndexView;
  });